import React, { useMemo } from 'react'
import noop from 'lib/function/noop'
import styled from 'styled-components'
import OfferAirportOptionsGroupedList from '../Airport/OfferAirportOptionsGroupedList'
import { CHARTER_FLIGHT_DETAILS } from 'constants/charterFlight'

const Wrapper = styled.div`
  position: relative; /* to make the <LoadingIndicator> work  */
`

interface Props {
  selectedAirport?: App.Airport
  onSelectAirport?: (airport: App.AirportLocation) => void
  charterBundleRoute: App.CharterBundleRoute
  withRadioButtons?: boolean
}

function CharterFlightOfferAirportOptionsList(props: Props) {
  const {
    selectedAirport,
    onSelectAirport = noop,
    charterBundleRoute,
    withRadioButtons,
  } = props

  const routeInfo = CHARTER_FLIGHT_DETAILS[charterBundleRoute]

  const airports = useMemo(() => [
    routeInfo.originAirport,
    ...routeInfo.feederFlightOrigins,
  ], [routeInfo])

  return <Wrapper>
    <OfferAirportOptionsGroupedList
      airports={airports}
      handleItemClick={onSelectAirport}
      selectedAirport={selectedAirport}
      withRadioButtons={withRadioButtons}
    />
  </Wrapper>
}

export default CharterFlightOfferAirportOptionsList
